import { type SortOrderType } from '../../types'
import { ButtonGroup, Button, Text } from '@chakra-ui/react'
import { useIntl } from 'react-intl'
import messages from './messages'

interface Props {
  sortOrder: SortOrderType
  onToggle: () => void
}

export default function SortOrderToggle({ sortOrder, onToggle }: Props) {
  const { formatMessage } = useIntl()
  return (
    <ButtonGroup size="sm" isAttached>
      <Button
        variant="outline"
        isActive={sortOrder === 'ASC'}
        _active={{ bg: 'gray.900', color: 'white' }}
        onClick={onToggle}
      >
        <Text>{formatMessage(messages.sortOldNew)}</Text>
      </Button>
      <Button
        variant="outline"
        isActive={sortOrder === 'DESC'}
        _active={{ bg: 'gray.900', color: 'white' }}
        onClick={onToggle}
      >
        <Text>{formatMessage(messages.sortNewOld)}</Text>
      </Button>
    </ButtonGroup>
  )
}
